<template>
  <v-container class="pa-0">
    <div class="logo">
      <div>
        <v-img src="@/assets/images/logos/logo_roxo.png" contain id="imageLogo" />
      </div>
    </div>

    <div id="onboarding-content" class="px-5">
      <div class="d-flex align-center justify-space-between mb-6">
        <div class="d-flex align-center" style="gap: 8px">
          <span class="progress-bar" :class="{ active: true }" />
          <span class="progress-bar" :class="{ active: step == 2 }" />
        </div>
        <span class="step-label">Passo {{ step }} de 2</span>
      </div>

      <!-- ===== Passo 1: recursos ===== -->
      <div v-show="step == 1">
        <div class="badge">
          <v-icon size="15" color="primary">mdi-creation</v-icon>
          Recursos inteligentes
        </div>

        <h1 class="header mt-4">Tudo o que você precisa em um só lugar</h1>
        <p class="sub-header mt-2">
          O Psicoplanner reúne recursos com inteligência artificial para você
          cuidar dos pacientes e deixar a burocracia no automático.
        </p>

        <div class="d-flex flex-column mt-6" style="gap: 12px">
          <div v-for="feature in features" :key="feature.title" class="feature-card">
            <span class="feature-icon">
              <v-icon color="primary" size="22">{{ feature.icon }}</v-icon>
            </span>
            <div>
              <div class="feature-title">{{ feature.title }}</div>
              <div class="feature-text">{{ feature.text }}</div>
            </div>
          </div>
        </div>

        <div class="d-flex align-center justify-end mt-8">

          <v-btn @click="step = 2" rounded color="primary" dark>
            Próximo
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- ===== Passo 2: paciente de exemplo ===== -->
      <div v-show="step == 2">
        <div class="badge">
          <v-icon size="15" color="primary">mdi-account-outline</v-icon>
          Primeiro paciente
        </div>

        <h1 class="header mt-4">Criamos um paciente de teste para você</h1>
        <p class="sub-header mt-2">
          A maioria dos recursos do Psicoplanner só é liberada depois que existe
          pelo menos um paciente cadastrado. Por isso, adicionamos
          automaticamente um <strong>paciente de exemplo</strong> — assim você
          já explora todo o potencial do sistema desde o primeiro acesso.
        </p>

        <div class="customer-card mt-6">
          <v-avatar color="primary" size="46">
            <span class="white--text font-weight-bold">PE</span>
          </v-avatar>
          <div class="flex-grow-1">
            <div class="feature-title">Paciente Exemplo</div>
            <div class="feature-text">
              Cadastrado automaticamente para demonstração
            </div>
          </div>
          <v-chip small color="#E7F6EF" text-color="#2C7A57">
            <v-icon left small color="#2C7A57">mdi-check</v-icon>
            Ativo
          </v-chip>
        </div>

        <div class="d-flex flex-column mt-6" style="gap: 14px">
          <div v-for="point in points" :key="point.title" class="d-flex" style="gap: 12px">
            <span class="point-icon">
              <v-icon color="primary" size="16">{{ point.icon }}</v-icon>
            </span>
            <span class="point-text">
              <strong>{{ point.title }}</strong> {{ point.text }}
            </span>
          </div>
        </div>

        <div class="d-flex align-center justify-space-between mt-8">
          <v-btn @click="step = 1" rounded color="primary" outlined>
            <v-icon left>mdi-chevron-left</v-icon>
            Voltar
          </v-btn>
          <v-btn @click="finish()" rounded color="primary" dark class="text-none">
            Explorar o sistema
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      step: 1,

      features: [
        {
          icon: "mdi-waveform",
          title: "Transcrição por IA",
          text: "Grave a sessão e receba a transcrição e um resumo pronto automaticamente.",
        },
        {
          icon: "mdi-link-variant",
          title: "Ficha de cadastro por link",
          text: "Envie a ficha de cadastro digital e receba preenchida pelo paciente.",
        },
        {
          icon: "mdi-whatsapp",
          title: "Lembretes por WhatsApp",
          text: "São enviados automaticamente 24h após criar o agendamento.",
        },
        {
          icon: "mdi-video-outline",
          title: "Sala de vídeo",
          text: "Própria, sem limite de tempo de sessão.",
        },
      ],

      points: [
        {
          icon: "mdi-lock-outline",
          title: "Comece com um paciente.",
          text: "Agenda, prontuário, transcrição e documentos só ficam disponíveis com pelo menos um paciente na sua clínica.",
        },
        {
          icon: "mdi-creation",
          title: "Explore sem compromisso.",
          text: "Use o paciente de teste para experimentar todos os recursos antes de cadastrar os seus pacientes reais.",
        },
        {
          icon: "mdi-refresh",
          title: "Pode desativar quando quiser.",
          text: "Depois de conhecer a plataforma, é só desativar o paciente de exemplo na tela de Pacientes.",
        },
      ],
    };
  },

  methods: {
    finish() {
      this.$router.push({ name: "Home" });
    },
  },
};
</script>

<style scoped lang="sass">
#onboarding-content
  max-width: 680px
  margin: 40px auto 60px

.progress-bar
  height: 6px
  width: 18px
  border-radius: 999px
  background: #E4DEF3
  transition: all .3s
  &.active
    width: 36px
    background: #624DE3

.step-label
  font-size: 12.5px
  font-weight: 600
  color: #9C99B0

.badge
  display: inline-flex
  align-items: center
  gap: 8px
  background: #F3EFFC
  border: 1px solid #EAE1F8
  border-radius: 999px
  padding: 6px 13px
  font-size: 12px
  font-weight: 600
  color: #6E5AAE

.header
  font-weight: 700
  font-size: 27px
  line-height: 1.2
  letter-spacing: -0.02em
  color: #33303E

.sub-header
  font-size: 15px
  line-height: 1.6
  color: #4E4B59

.feature-card
  display: flex
  gap: 14px
  align-items: flex-start
  border: 1px solid #EEEAF6
  border-radius: 16px
  padding: 16px

.feature-icon
  width: 42px
  height: 42px
  flex: 0 0 auto
  border-radius: 12px
  background: #EDE7FB
  display: flex
  align-items: center
  justify-content: center

.feature-title
  font-weight: 700
  font-size: 15px
  color: #2E2B45

.feature-text
  font-size: 13.5px
  line-height: 1.45
  color: #8A87A0
  margin-top: 3px

.customer-card
  display: flex
  align-items: center
  gap: 14px
  background: #F6F2FD
  border: 1px solid #E7DEF8
  border-radius: 16px
  padding: 16px 18px

.point-icon
  width: 26px
  height: 26px
  flex: 0 0 auto
  border-radius: 8px
  background: #EDE7FB
  display: flex
  align-items: center
  justify-content: center

.point-text
  font-size: 14px
  line-height: 1.5
  color: #4E4B59
  strong
    color: #3B3856
    font-weight: 600

.skip-link
  font-size: 14px
  font-weight: 600
  color: #8A87A0
  text-decoration: none

.logo
  justify-content: center
  display: flex

/* desktop */
@media (min-width: 960px)
  #imageLogo
    width: 350px
    height: 60px

  .logo
    margin-top: 52px

/* mobile */
@media (max-width: 960px)
  #imageLogo
    width: 300px
    height: 44px

  .logo
    margin-top: 40px

  .customer-card
    flex-wrap: wrap
</style>
